import { createContext, useContext, type ReactNode, type FC } from 'react';

type HomePageContextType = {
    isBot: boolean;
    isDesktop: boolean;
    isMobile: boolean;
    isTablet: boolean;
    isLoggedInUser: boolean;
    userType: string;
    priceBookName: string;
    isTrade: boolean;
    isTopDisplayAdEnabled?: boolean;
    isBottomDisplayAdEnabled?: boolean;
    isRemoveTopHeroBannerTestVariant?: boolean;
    isEvergreenCollectionsTestVariant?: boolean;
};

const HomePageContext = createContext<HomePageContextType>({
    isBot: false,
    isDesktop: false,
    isMobile: false,
    isTablet: false,
    isLoggedInUser: false,
    priceBookName: 'DEFAULT',
    isTrade: false,
    userType: '',
    isTopDisplayAdEnabled: false,
    isBottomDisplayAdEnabled: false,
    isRemoveTopHeroBannerTestVariant: false,
    isEvergreenCollectionsTestVariant: false,
});

type ServerVarsProviderProps = {
    children: ReactNode;
} & HomePageContextType;

export const useHomePageContext = (): HomePageContextType => {
    const context = useContext(HomePageContext);
    if (!context) {
        throw new Error('useHomePageContext must be used within a HomePageContextProvider');
    }
    return context;
};

export const HomePageContextProvider: FC<ServerVarsProviderProps> = ({
    children,
    isBot,
    isDesktop,
    isMobile,
    isTablet,
    isLoggedInUser,
    userType,
    priceBookName,
    isTrade,
    isTopDisplayAdEnabled,
    isBottomDisplayAdEnabled,
    isRemoveTopHeroBannerTestVariant,
    isEvergreenCollectionsTestVariant,
}) => {
    return (
        <HomePageContext
            value={{
                isBot,
                isMobile,
                isTablet,
                isDesktop,
                isLoggedInUser,
                userType,
                priceBookName,
                isTrade,
                isTopDisplayAdEnabled,
                isBottomDisplayAdEnabled,
                isRemoveTopHeroBannerTestVariant,
                isEvergreenCollectionsTestVariant,
            }}
        >
            {children}
        </HomePageContext>
    );
};
